import { useEffect, useState } from 'react';

/**
 * 検証環境（dev.quiz-study.com）の目印。本番と見分けるため。ページの高さは変えない（帯は出さない）。
 * - <html data-env="staging"> を付ける：各画面のロゴの部分（スタジオの左のメニュー、主催者の画面のヘッダー）を黄色にする
 * - スマホのブラウザのアドレスバーの色（theme-color）を黄色にする
 * - ロゴの無い画面（参加者・投影・リモコン・ログインなど）では、左下に小さな「検証環境」の札を出す（画面の操作の邪魔にならないよう、押せない）
 * サーバーの /api/env を1回だけ聞く（開発機・本番では何もしない）
 */
export function EnvBanner() {
  const [env, setEnv] = useState<string | null>(null);
  useEffect(() => {
    fetch('/api/env')
      .then((r) => (r.ok ? (r.json() as Promise<{ appEnv?: string }>) : null))
      .then((j) => setEnv(j?.appEnv ?? null))
      .catch(() => setEnv(null));
  }, []);
  useEffect(() => {
    if (env !== 'staging') return;
    const root = document.documentElement;
    root.dataset.env = 'staging';
    const yellow = getComputedStyle(root).getPropertyValue('--color-yellow').trim() || '#FFC72C';
    let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'theme-color';
      document.head.appendChild(meta);
    }
    meta.content = yellow;
  }, [env]);
  if (env !== 'staging') return null;
  return (
    <div className="qs-env-pill" role="note" data-testid="env-banner" title="検証環境です（テスト用のデータ。本物の購入やお知らせには使われません）">
      検証環境
    </div>
  );
}
